export const CONNECTION_CATEGORY_FILE = 'file';
export const CONNECTION_CATEGORY_REST = 'rest';
export const CONNECTION_CATEGORY_DATABASE = 'database';
export const CONNECTION_CATEGORY_DATA_MAP = 'data_map';
export const CONNECTION_CATEGORY_SOAP = 'soap';
export const CONNECTION_CATEGORY_WEBHOOK = 'webhook';
export const CONNECTION_CATEGORY_TEMPLATIZED_API = 'templatized_api';
export const CONNECTION_CATEGORY_TEMPLATIZED_API_MULTI = 'templatized_api_multi';
export const CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT = 'templatized_script';
export const CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT = 'email_script';
export const CONNECTION_CATEGORY_FILE_UPLOAD = 'file_upload';
export const CONNECTION_CATEGORY_KAFKA = 'kafka';
export const CONNECTION_CATEGORY_NEXLA_MONITOR = 'nexla_monitor';
export const CONNECTION_CATEGORY_NOSQL = 'nosqldoc';
export const CONNECTION_CATEGORY_VECTOR_DB = 'vectordb';
export const CONNECTION_CATEGORY_SYSLOG = 'syslog';

// this is a list of connection categories that can need data to be provided by the user
export const userDataCategories = [
  CONNECTION_CATEGORY_WEBHOOK,
  CONNECTION_CATEGORY_FILE_UPLOAD,
  CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT,
  CONNECTION_CATEGORY_SYSLOG,
];

export const CONNECTION_CATEGORY_BUCKET_TYPE_FILES = [
  's3',
  'gcs',
  'mercury_s3',
  'neptune_s3',
  'azure_blb',
  'azure_data_lake',
  'delta_lake_s3',
  'delta_lake_azure_data_lake',
  'min_io_s3',
];

export const TIME_BASED_METRICS_FILE_CONNECTORS = ['s3_iceberg'];
export const ID_BASED_FILE_CONNECTORS = ['gdrive', 'sharepoint'];
export const ID_BASED_FILE_CONNECTORS_WITH_LEAF_ID_ONLY = ['gdrive'];
export const ID_BASED_FILE_CONNECTORS_WITH_FULL_PATH = ['sharepoint'];

export const CDC_FLOW_WITH_DB_READ_ONLY_CONNECTORS = ['netsuite_jdbc'];

export const CONNECTOR_CODE_SQL_RUNNER = 'sql_runner';
export const CONNECTOR_CODE_SQL_RUNNER_DISPLAY_NAME = 'SQL Automation';

export const STREAMING_OR_USER_DATA_CATEGORIES = [...userDataCategories, CONNECTION_CATEGORY_KAFKA];
